import React from 'react';
import useLanguage from '../hooks/useLanguage';
import { formatShortDateTime } from '../utils/dateFormatter';

/**
 * The recorded answer to "would you host this guest again?", read-only, inside a completed clean's
 * field-team report. Staff only — the API never sends it to owners (L47), so this renders nothing
 * for them. Who answered is recorded, never inferred from the assignee (D5).
 */
const GuestAssessmentSummary = ({ assessment, className = 'small mb-1' }) => {
  const { t, language } = useLanguage();
  if (!assessment?.answer) return null;

  const reason = assessment.reasonCode
    ? t(`tasks.guestAssessment.reasons.${assessment.reasonCode}`)
    : null;

  return (
    <div className={className}>
      <div>
        <span className="text-muted">{t('tasks.guestAssessment.summaryLabel')} </span>
        <strong>{t(`tasks.guestAssessment.${assessment.answer}`)}</strong>
        {reason && <span>{` (${reason})`}</span>}
      </div>
      {assessment.note && <div>{assessment.note}</div>}
      {(assessment.answeredByName || assessment.answeredAt) && (
        <div className="text-muted" style={{ fontSize: '0.75rem' }}>
          {assessment.answeredByName && `${t('tasks.card.completedBy')} ${assessment.answeredByName}`}
          {assessment.answeredByName && assessment.answeredAt && ' • '}
          {assessment.answeredAt && formatShortDateTime(assessment.answeredAt, language)}
        </div>
      )}
    </div>
  );
};

export default GuestAssessmentSummary;
